


















































































import { Component, Vue } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import ElementInputText from '@/components/elements/ElementInputText.vue';
import ElementInputOptions from '@/components/elements/ElementInputOptions.vue';
import ElementInputNumber from '@/components/elements/ElementInputNumber.vue';
import ElementInputMultiRange from '@/components/elements/ElementInputMultiRange.vue';
import ElementStaticText from '@/components/elements/ElementStaticText.vue';
import Jumbotron from '@/components/Jumbotron.vue';
import BaseTabs from '@/components/Tabs.vue';
import BaseFilter from '@/components/BaseFilter.vue';
import CardFormElement from '@/components/cards/CardFormElement.vue';
import ModalTagConfig from '@/components/modals/TagConfig.vue';
import { Form } from '@/models/Form';
import { FormElement, FormElementData, FormElementTag, FormElementType } from '@/models/FormElement';
import { BModal, BDropdown, BDropdownItem } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import { User } from '@/models/User';

@Component({
    name: 'FormElements',
    components: {
        draggable,
        'jumbotron': Jumbotron,
        'base-tabs': BaseTabs,
        'base-filter': BaseFilter,
        'card-form-element': CardFormElement,
        'b-modal': BModal,
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'input-text': ElementInputText,
        'input-options': ElementInputOptions,
        'input-number': ElementInputNumber,
        'input-multirange': ElementInputMultiRange,
        'static-text': ElementStaticText,
        'modal-tag-config': ModalTagConfig,
    },
    computed: mapGetters({
        account: 'account/account',
        forms: 'forms/all',
        formElements: 'formElements/all',
        formElementTags: 'formElementTags/all',
        formElementTypes: 'formElementTypes/all',
    }),
})
export default class FormElements extends Vue {
    loading = false;
    error = '';
    id!: number;
    uri!: string;
    input: any = {
        id: null,
        form: null,
        title: '',
        weight: 0,
        type: null,
        tags: [],
        visibilityRuleSetRefs: [],
        params: new FormElementData({}),
    };

    // getters
    forms!: Form[];
    account!: User;
    formElements!: { [id: number]: FormElement[] };
    formElementTags!: { [id: number]: FormElementTag[] };
    formElementTypes!: FormElementType[];

    get form(): Form | null {
        return this.forms.find((f: Form) => f.id === this.id) || null;
    }

    get elements(): FormElement[] {
        if (!this.form) {
            return [];
        }

        return this.form.elements.filter((element: FormElement) => {
            return (
                element.tags.some((id: number) => {
                    return this.filters.includes(id);
                }) || !this.filters.length
            );
        });
    }

    set elements(elements: FormElement[]) {
        const index = this.forms.findIndex((f: Form) => this.id === f.id);
        // TODO should be a mutation
        this.forms[index].elements = elements;
    }

    async created() {
        this.id = parseInt(this.$router.currentRoute.params.id, 10);
        this.uri = '/api/forms/' + this.id;

        try {
            await this.$store.dispatch('formElementTags/init', this.id);
        } catch (e) {
            this.error = e;
        }

        try {
            await this.$store.dispatch('formElementTypes/init');
            this.input.type = Object.values(this.formElementTypes)[0].id;
        } catch (e) {
            this.error = e;
        }
    }
    get filters() {
        return !this.$route.query.filter ? [] : JSON.parse(this.$route.query.filter.toString());
    }

    async addFormElement(formElement: FormElement) {
        const id = parseInt(this.$router.currentRoute.params.id, 10);

        try {
            const element = await this.$store.dispatch('formElements/create', {
                title: formElement.title,
                form: `/api/forms/${id}`,
                type: `/api/form_element_types/${formElement.type}`,
                weight: this.form && this.form.elements ? this.form.elements.length : 0,
            });
            this.$store.commit('forms/setElement', element);

            this.input = {
                id: null,
                form: null,
                title: '',
                weight: 0,
                type: this.formElementTypes[0].id,
                tags: [],
                visibilityRuleSetRefs: [],
                params: new FormElementData({}),
            };
        } catch (e) {
            this.error = e;
        }
    }

    async onMove() {
        if (this.form) {
            const formId = parseInt(this.$router.currentRoute.params.id, 10);
            const elements = this.form.elements;

            if (elements) {
                const data = elements.map((element: FormElement, i: number) => {
                    return {
                        '@id': `/api/form_elements/${element.id}`,
                        '@type': 'FormElement',
                        'weight': i,
                    };
                });

                await this.$store.dispatch('forms/update', {
                    owner: this.account,
                    formData: {
                        id: formId,
                        elements: data,
                    },
                });
            }
        }
    }
}
